export enum PaymentModeEnum {
  DISABLED = 'disabled',
  STRIPE = 'stripe',
  INGENICO = 'ingenico'
}
